import React, { useContext, useEffect, useState } from "react";
import {
  Stack,
  Box,
  ListItemText,
  Typography,
  TextField,
  InputAdornment,
  TableBody,
  TableRow,
  TableHead,
  TableContainer,
  Paper,
  Table,
  TableCell,
  styled,
  Backdrop,
  CircularProgress,
  Button,
  tableCellClasses,
  Skeleton,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Grid,
  Divider,
  TablePagination,
  CardContent,
  Card,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Menu,
  Fade,
} from "@mui/material";
import InvirteLogoComponent from "../../components/InvirteLogo";
import { Dashboard, Edit, Search } from "@mui/icons-material";
import useSnack from "../../hooks/useSnack";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import useApi from "../../hooks/useApi";
import { Link, useLocation } from "react-router-dom";
import SnackAlert from "../../components/SnackAlert";
import EditIcon from "@mui/icons-material/Edit";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import HeaderAdmin, { AdminContextProvide } from "../../components/headerAdmin";
import NorthEastIcon from "@mui/icons-material/NorthEast";

import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DownloadIcon from "@mui/icons-material/Download";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {
  ModalAcceptInvestment,
  ModalContactedClient,
  ModalDisableInvestment,
  ModalRejectInvestment,
} from "./Modals";
import BlockIcon from "@mui/icons-material/Block";
import PersonIcon from "@mui/icons-material/Person";
import NewProperty from "../newProperty";

const Searcher = (mainData, filterQuery, type = "name") => {
  let tempQuery = filterQuery.toLowerCase();

  let response;

  if (type === "property_name") {
    response = mainData.filter((x) =>
      x?.State?.name?.toLowerCase().includes(tempQuery)
    );
  }
  if (type === "user_name") {
    response = mainData.filter((x) =>
      x?.User?.username?.toLowerCase().includes(tempQuery)
    );
  }
  if (type === "user_email") {
    response = mainData.filter((x) =>
      x?.User?.username?.toLowerCase().includes(tempQuery)
    );
  }
  if (type === "property_value") {
    response = mainData.filter((x) =>
      x?.State?.price?.toString().includes(tempQuery.toString())
    );
  }
  if (type === "user_phone") {
    const normalizePhone = (phone) => phone.replace(/\D/g, ""); // Elimina todos los caracteres no numéricos
    response = mainData.filter((x) =>
      normalizePhone(x?.User?.Profile?.contact[0]?.phone).includes(
        normalizePhone(tempQuery)
      )
    );
  }

  if (type === "name") {
    response = mainData.filter((x) => x.name.toLowerCase().includes(tempQuery));
  }

  if (type === "name_invest") {
    response = mainData.filter((x) =>
      x.Project.name.toLowerCase().includes(tempQuery)
    );
  }

  if (type === "objective") {
    response = mainData.filter((x) =>
      x.objective.toLowerCase().includes(tempQuery)
    );
  }
  if (type === "location") {
    response = mainData.filter((x) =>
      x.location.toLowerCase().includes(tempQuery)
    );
  }
  if (type === "m2") {
    response = mainData.filter((x) => x.m2.toString().includes(tempQuery));
  }

  if (type === "phone") {
    const normalizePhone = (phone) => phone.replace(/\D/g, ""); // Elimina todos los caracteres no numéricos
    response = mainData.filter((x) =>
      normalizePhone(x.phone).includes(normalizePhone(tempQuery))
    );
  }
  if (type === "investment_amount") {
    response = mainData.filter((x) =>
      x.invested_value.toString().includes(tempQuery.toString())
    );
  }
  return response;
};

const InterestedProperty = ({
  showSnack,
  setOpenBackDrop,
  loadApi,
  openBackDrop,
}) => {
  const [currentProject, setCurrentProject] = useState();
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [modalOpenAccept, setModalOpenAccept] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [modalOpenReject, setModalOpenReject] = useState(false);
  const [filterType, setFilterType] = useState("property_name");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  const formatNumberWithDots = (number) => {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleUpdateClientStatus = () => {
    setIsLoadingButton(true);

    loadApi(`superadmin/transaction/${currentProject}`, true, "put", {
      status: "contacted",
    })
      .then((response) => {
        let tempData = mainData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        let tempData2 = filteredData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        setFilteredData(tempData2);
        setMainData(tempData);
        showSnack("El cliente fue contactado", "success");
        setModalOpenAccept(false);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setIsLoadingButton(false);
      });
  };

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Interesados Inmuebles";
    setOpenBackDrop(true);
    loadApi("superadmin/transaction", true, "get")
      .then((response) => {
        setMainData(response.data);
        setFilteredData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  }, []);

  console.log(mainData);
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Interesados en inmuebles
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            value={searchQuery}
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"property_name"}>Nombre inmueble</MenuItem>
              <MenuItem value={"property_value"}>Precio inmueble</MenuItem>
              <MenuItem value={"user_phone"}>Teléfono contacto</MenuItem>
              <MenuItem value={"user_email"}>Email usuario</MenuItem>
              <MenuItem value={"user_name"}>Nombre usuario</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Inversiones encontradas
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="25%">Inmueble</StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Precio inmueble
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Nombre usuario
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Teléfono usuario
                    </StyledTableCell>
                    <StyledTableCell>Email usuario</StyledTableCell>
                    <StyledTableCell align="center">Acciones</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell width="25%">{row?.State?.name}</TableCell>
                      <TableCell align="right">{`${formatNumberWithDots(
                        row?.State?.price || "0"
                      )} €`}</TableCell>
                      <TableCell>{row?.User?.name}</TableCell>
                      <TableCell align="center">
                        {row?.User?.Profile?.contact[0]?.phone ||
                          "No disponible"}
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                      <TableCell>{row?.User?.username}</TableCell>
                      <TableCell align="center">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 1, // Espaciado entre ícono y texto
                            cursor: "pointer", // Cambia el cursor para indicar que es clicable
                          }}
                          onClick={() => {
                            setCurrentProject(row.id);
                            setModalOpenAccept(true);
                          }}
                          title="Establecer como contactado"
                        >
                          <CheckIcon />
                          <Typography variant="body2">Contactado</Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>

      <ModalContactedClient
        isLoadingButton={isLoadingButton}
        handleDisableInvestment={handleUpdateClientStatus}
        modalOpenAccept={modalOpenAccept}
        setModalOpenAccept={setModalOpenAccept}
      />
    </>
  );
};

const ContactedProperty = ({
  showSnack,
  setOpenBackDrop,
  loadApi,
  openBackDrop,
}) => {
  const [currentProject, setCurrentProject] = useState();
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [modalOpenAccept, setModalOpenAccept] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [modalOpenReject, setModalOpenReject] = useState(false);
  const [filterType, setFilterType] = useState("property_name");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  const formatNumberWithDots = (number) => {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Interesados contactados";
    setOpenBackDrop(true);
    loadApi("superadmin/transaction/contacted", true, "get")
      .then((response) => {
        setMainData(response.data);
        setFilteredData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  }, []);

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Interesados contactados
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            value={searchQuery}
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"property_name"}>Nombre inmueble</MenuItem>
              <MenuItem value={"property_value"}>Precio inmueble</MenuItem>
              <MenuItem value={"user_phone"}>Teléfono contacto</MenuItem>
              <MenuItem value={"user_email"}>Email usuario</MenuItem>
              <MenuItem value={"user_name"}>Nombre usuario</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Inversiones encontradas
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="25%">Inmueble</StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Precio inmueble
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Nombre usuario
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Teléfono usuario
                    </StyledTableCell>
                    <StyledTableCell>Email usuario</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell width="25%">{row?.State?.name}</TableCell>
                      <TableCell align="right">{`${formatNumberWithDots(
                        row?.State?.price || "0"
                      )} €`}</TableCell>
                      <TableCell>{row?.User?.name}</TableCell>
                      <TableCell align="center">
                        {row?.User?.Profile?.contact[0]?.phone ||
                          "No disponible"}
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                      <TableCell>{row?.User?.username}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>
    </>
  );
};

const InvestmentsAccepted = ({
  showSnack,
  setOpenBackDrop,
  loadApi,
  openBackDrop,
}) => {
  const [currentProject, setCurrentProject] = useState();
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [modalOpenAccept, setModalOpenAccept] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [modalOpenReject, setModalOpenReject] = useState(false);
  const [filterType, setFilterType] = useState("name_invest");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleDisableInvestment = () => {
    setIsLoadingButton(true);
    loadApi(`superadmin/investment/${currentProject}`, true, "put", {
      status: "rejected",
    })
      .then((response) => {
        let tempData = mainData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        let tempData2 = filteredData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        setFilteredData(tempData2);
        setMainData(tempData);
        showSnack(
          "La inversión ha sido deshabilitada, pendiente por aprobar",
          "success"
        );
        setModalOpenAccept(false);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setIsLoadingButton(false);
      });
  };

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Inversiones Aceptadas";
    setOpenBackDrop(true);
    loadApi("superadmin/investment/approved", true, "get")
      .then((response) => {
        setMainData(response.data);
        setFilteredData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  }, []);

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Inversiones aceptadas
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            value={searchQuery}
            type={
              filterType === "phone" || filterType === "investment_amount"
                ? "number"
                : "text"
            }
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name_invest"}>Nombre</MenuItem>
              <MenuItem value={"phone"}>Teléfono contacto</MenuItem>
              <MenuItem value={"investment_amount"}>
                Monto de inversión
              </MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Inversiones encontradas
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="30%">
                      Proyecto invertido
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Inversor
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Número de contacto
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Monto invertido
                    </StyledTableCell>
                    <StyledTableCell align="center">Documento</StyledTableCell>
                    <StyledTableCell align="center">Acciones</StyledTableCell>
                    {/* <StyledTableCell align="center">Acciones</StyledTableCell> */}
                    {/* Añade más columnas aquí si es necesario */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell width="30%">{row?.Project?.name}</TableCell>
                      <TableCell>{row?.User?.name}</TableCell>
                      <TableCell>{row?.phone}</TableCell>
                      <TableCell align="right">
                        {parseInt(row?.invested_value).toLocaleString("es-CO")}{" "}
                        Є
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                      <TableCell title="Descargar documento" align="center">
                        <IconButton
                          target="_blank"
                          LinkComponent={Link}
                          to={row?.document[0]?.url || "No disponible"}
                          download={true}
                          size="small"
                        >
                          <DownloadIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell title="Deshabilitar" align="center">
                        <Box
                          title="Deshabilitar"
                          onClick={() => {
                            setCurrentProject(row.id);
                            setModalOpenAccept(true);
                          }}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 1, // Espaciado entre ícono y texto
                            cursor: "pointer", // Cambia el cursor para indicar que es clicable
                          }}
                        >
                          <BlockIcon />
                          <Typography>Rechazar</Typography>
                        </Box>
                      </TableCell>
                      {/* <TableCell align="center">
                    <IconButton
                      size="small"
                      title="Aceptar Inversión"
                      onClick={() => {
                        setCurrentProject(row.id);
                        setModalOpenAccept(true);
                      }}
                    >
                      <CheckIcon />
                    </IconButton>
                    <IconButton
                      size="small"
                      title="Rechazar Inversión"
                      onClick={() => {
                        setCurrentProject(row.id);
                        setModalOpenReject(true);
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>

      <ModalDisableInvestment
        isLoadingButton={isLoadingButton}
        handleDisableInvestment={handleDisableInvestment}
        modalOpenAccept={modalOpenAccept}
        setModalOpenAccept={setModalOpenAccept}
      />
    </>
  );
};

const InvestmentsRejected = ({
  showSnack,
  setOpenBackDrop,
  loadApi,
  openBackDrop,
}) => {
  const [currentProject, setCurrentProject] = useState();
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [modalOpenAccept, setModalOpenAccept] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [modalOpenReject, setModalOpenReject] = useState(false);
  const [filterType, setFilterType] = useState("name_invest");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleAcceptInvestment = () => {
    setIsLoadingButton(true);
    loadApi(`superadmin/investment/${currentProject}`, true, "put", {
      status: "approved",
    })
      .then((response) => {
        let tempData = mainData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        let tempData2 = filteredData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        setFilteredData(tempData2);
        setMainData(tempData);
        showSnack(response.data.message, "success");
        setModalOpenAccept(false);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setIsLoadingButton(false);
      });
  };
  const handleRejectInvestment = () => {
    setIsLoadingButton(true);
    loadApi(`superadmin/investment/${currentProject}`, true, "put", {
      status: "rejected",
    })
      .then((response) => {
        let tempData = mainData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        let tempData2 = filteredData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        setFilteredData(tempData2);
        setMainData(tempData);
        showSnack(response.data.message, "success");
        setModalOpenReject(false);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setIsLoadingButton(false);
      });
  };
  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Inversiones Rechazadas";
    setOpenBackDrop(true);
    loadApi("superadmin/investment/rejected", true, "get")
      .then((response) => {
        setMainData(response.data);
        setFilteredData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  }, []);

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Inversiones rechazadas
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            value={searchQuery}
            type={
              filterType === "phone" || filterType === "investment_amount"
                ? "number"
                : "text"
            }
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name_invest"}>Nombre</MenuItem>
              <MenuItem value={"phone"}>Teléfono contacto</MenuItem>
              <MenuItem value={"investment_amount"}>
                Monto de inversión
              </MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Inversiones encontradas
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="30%">
                      Proyecto a invertir
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Inversor
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Número de contacto
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Monto de inversión
                    </StyledTableCell>
                    <StyledTableCell align="center">Documento</StyledTableCell>
                    <StyledTableCell align="center">Acciones</StyledTableCell>
                    {/* Añade más columnas aquí si es necesario */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell width="30%">{row?.Project?.name}</TableCell>
                      <TableCell>{row?.User?.name}</TableCell>
                      <TableCell>{row.phone}</TableCell>
                      <TableCell align="right">
                        {parseInt(row.invested_value).toLocaleString("es-CO")} Є
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                      <TableCell title="Descargar documento" align="center">
                        <IconButton
                          target="_blank"
                          LinkComponent={Link}
                          to={row.document[0].url || "Documento no disponible"}
                          download={true}
                          size="small"
                        >
                          <DownloadIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          title="Aceptar Inversión"
                          onClick={() => {
                            setCurrentProject(row.id);
                            setModalOpenAccept(true);
                          }}
                        >
                          <CheckIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>

      <ModalAcceptInvestment
        isLoadingButton={isLoadingButton}
        handleAcceptInvestment={handleAcceptInvestment}
        modalOpenAccept={modalOpenAccept}
        setModalOpenAccept={setModalOpenAccept}
      />
      <ModalRejectInvestment
        isLoadingButton={isLoadingButton}
        handleRejectInvestment={handleRejectInvestment}
        modalOpenReject={modalOpenReject}
        setModalOpenReject={setModalOpenReject}
      />
    </>
  );
};

const InvestmentsPending = ({
  showSnack,
  setOpenBackDrop,
  loadApi,
  openBackDrop,
}) => {
  const [currentProject, setCurrentProject] = useState();
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [modalOpenAccept, setModalOpenAccept] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [modalOpenReject, setModalOpenReject] = useState(false);
  const [filterType, setFilterType] = useState("name_invest");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleAcceptInvestment = () => {
    setIsLoadingButton(true);

    loadApi(`superadmin/investment/${currentProject}`, true, "put", {
      status: "approved",
    })
      .then((response) => {
        let tempData = mainData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        let tempData2 = filteredData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        setFilteredData(tempData2);
        setMainData(tempData);
        showSnack(response.data.message, "success");
        setModalOpenAccept(false);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setIsLoadingButton(false);
      });
  };
  const handleRejectInvestment = () => {
    setIsLoadingButton(true);

    loadApi(`superadmin/investment/${currentProject}`, true, "put", {
      status: "rejected",
    })
      .then((response) => {
        let tempData = mainData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        let tempData2 = filteredData.filter(
          (x) => parseInt(x.id) !== parseInt(currentProject)
        );
        setFilteredData(tempData2);
        setMainData(tempData);
        showSnack(response.data.message, "success");
        setModalOpenReject(false);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => {
        setIsLoadingButton(false);
      });
  };
  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Inversiones Pendientes";
    setOpenBackDrop(true);
    loadApi("superadmin/investment", true, "get")
      .then((response) => {
        setMainData(response.data);
        setFilteredData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  }, []);

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Inversiones pendientes
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            value={searchQuery}
            type={
              filterType === "phone" || filterType === "investment_amount"
                ? "number"
                : "text"
            }
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name_invest"}>Nombre</MenuItem>
              <MenuItem value={"phone"}>Teléfono contacto</MenuItem>
              <MenuItem value={"investment_amount"}>
                Monto de inversión
              </MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Inversiones encontradas
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="30%">
                      Proyecto a invertir
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Inversor
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Número de contacto
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Monto de inversión
                    </StyledTableCell>
                    <StyledTableCell align="center">Documento</StyledTableCell>
                    <StyledTableCell align="center">Acciones</StyledTableCell>
                    {/* Añade más columnas aquí si es necesario */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell width="30%">{row?.Project?.name}</TableCell>
                      <TableCell>{row?.User?.name}</TableCell>
                      <TableCell>{row.phone}</TableCell>
                      <TableCell align="right">
                        {parseInt(row.invested_value).toLocaleString("es-CO")} Є
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                      <TableCell title="Descargar documento" align="center">
                        <IconButton
                          target="_blank"
                          LinkComponent={Link}
                          to={row.document[0].url || "No disponible"}
                          download={true}
                          size="small"
                        >
                          <DownloadIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          title="Aceptar Inversión"
                          onClick={() => {
                            setCurrentProject(row.id);
                            setModalOpenAccept(true);
                          }}
                        >
                          <CheckIcon />
                        </IconButton>
                        <IconButton
                          size="small"
                          title="Rechazar Inversión"
                          onClick={() => {
                            setCurrentProject(row.id);
                            setModalOpenReject(true);
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>

      <ModalAcceptInvestment
        isLoadingButton={isLoadingButton}
        handleAcceptInvestment={handleAcceptInvestment}
        modalOpenAccept={modalOpenAccept}
        setModalOpenAccept={setModalOpenAccept}
      />
      <ModalRejectInvestment
        isLoadingButton={isLoadingButton}
        handleRejectInvestment={handleRejectInvestment}
        modalOpenReject={modalOpenReject}
        setModalOpenReject={setModalOpenReject}
      />
    </>
  );
};

const ProjectsRejected = ({
  openBackDrop,
  setOpenBackDrop,
  loadApi,
  showSnack,
}) => {
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filterType, setFilterType] = useState("name");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  function dateToInput(fechaOriginal) {
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${día}-${mes}-${año}`;
    } else return fechaOriginal;
  }

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Proyectos Rechazados";
    setOpenBackDrop(true);
    loadApi("superadmin/projects/rejected", true, "get")
      .then((response) => {
        setFilteredData(response.data);
        setMainData(response.data);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setOpenBackDrop(false));
  }, []);
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Proyectos rechazados
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            type={filterType === "objective" ? "number" : "text"}
            value={searchQuery}
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name"}>Nombre</MenuItem>
              <MenuItem value={"objective"}>Objetivo</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Proyectos encontrados
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="30%">
                      Nombre proyecto
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Objetivo
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Rentabilidad
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Fecha de Lanzamiento
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Ver Proyecto
                    </StyledTableCell>
                    {/* Añade más columnas aquí si es necesario */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell sx={{ whiteSpace: "nowrap" }} width="30%">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">
                        {parseInt(row.objective).toLocaleString("es-CO")} Є
                      </TableCell>
                      <TableCell align="right">
                        {row.esti_profitability}%
                      </TableCell>
                      <TableCell align="center">
                        {dateToInput(row.initial_date)}
                      </TableCell>
                      <TableCell title="Ver Proyecto" align="center">
                        <IconButton
                          LinkComponent={Link}
                          to={"/dashboard/manage/project/" + row.id}
                          size="small"
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>
    </>
  );
};

const ProjectsPending = ({
  openBackDrop,
  setOpenBackDrop,
  loadApi,
  showSnack,
}) => {
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterType, setFilterType] = useState("name");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  function dateToInput(fechaOriginal) {
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${día}-${mes}-${año}`;
    } else return fechaOriginal;
  }

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Proyectos Pendientes";
    setOpenBackDrop(true);
    loadApi("superadmin/projects/pendings", true, "get")
      .then((response) => {
        setFilteredData(response.data);
        setMainData(response.data);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setOpenBackDrop(false));
  }, []);
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Proyectos pendientes
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            type={filterType === "objective" ? "number" : "text"}
            value={searchQuery}
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name"}>Nombre</MenuItem>
              <MenuItem value={"objective"}>Objetivo</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Proyectos encontrados
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="30%">
                      Nombre proyecto
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Objetivo
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Rentabilidad
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Fecha de Lanzamiento
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Ver Proyecto
                    </StyledTableCell>
                    {/* Añade más columnas aquí si es necesario */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell sx={{ whiteSpace: "nowrap" }} width="30%">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">
                        {parseInt(row.objective).toLocaleString("es-CO")} Є
                      </TableCell>
                      <TableCell align="right">
                        {row.esti_profitability}%
                      </TableCell>
                      <TableCell align="center">
                        {dateToInput(row.initial_date)}
                      </TableCell>
                      <TableCell title="Ver Proyecto" align="center">
                        <IconButton
                          LinkComponent={Link}
                          to={"/dashboard/manage/project/" + row.id}
                          size="small"
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>
    </>
  );
};

const ProjectsAccept = ({
  showSnack,
  setOpenBackDrop,
  loadApi,
  openBackDrop,
}) => {
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filterType, setFilterType] = useState("name");

  const [users, setUsers] = useState([]);

  useEffect(() => {
    loadApi("superadmin/users", true, "get")
      .then((response) => {
        setUsers(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  function dateToInput(fechaOriginal) {
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${día}-${mes}-${año}`;
    } else return fechaOriginal;
  }

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Proyectos Aceptados";
    setOpenBackDrop(true);
    loadApi("superadmin/projects", true, "get")
      .then((response) => {
        setFilteredData(response.data);
        setMainData(response.data);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setOpenBackDrop(false));
  }, []);

  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Proyectos aceptados
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            type={filterType === "objective" ? "number" : "text"}
            value={searchQuery}
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name"}>Nombre</MenuItem>
              <MenuItem value={"objective"}>Objetivo</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Proyectos Encontrados
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="30%">
                      Nombre proyecto
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Creado por
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Objetivo
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Cantidad de inversores
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Fecha inicial
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Fecha final
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      Días restantes
                    </StyledTableCell>
                    <StyledTableCell align="center">Editar</StyledTableCell>
                    {/* Añade más columnas aquí si es necesario */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell width="30%">{row.name}</TableCell>
                      <TableCell align="right">
                        {users.filter((x) => x.id === row.user_id)[0]?.name}
                      </TableCell>
                      <TableCell align="right">
                        {parseInt(row.objective).toLocaleString("es-CO")} Є
                      </TableCell>
                      <TableCell align="right">{row.cant_investors}</TableCell>
                      <TableCell align="center">
                        {dateToInput(row.initial_date)}
                      </TableCell>
                      <TableCell align="center">
                        {dateToInput(row.final_date)}
                      </TableCell>
                      <TableCell align="right">{row.remaining_days}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          title="Editar"
                          LinkComponent={Link}
                          to={"/dashboard/preview/project/" + row.id}
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>
    </>
  );
};

const PropertyAccept = ({
  showSnack,
  setOpenBackDrop,
  loadApi,
  openBackDrop,
}) => {
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filterType, setFilterType] = useState("name");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState({});

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (event, propertyId) => {
    setMenuAnchorEl((prev) => ({
      ...prev,
      [propertyId]: event.currentTarget,
    }));
  };

  const handleMenuClose = (propertyId) => {
    setMenuAnchorEl((prev) => ({
      ...prev,
      [propertyId]: null,
    }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleDeleteClick = (property) => {
    setSelectedProperty(property);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      setOpenBackDrop(true);
      await loadApi(`superadmin/states/${selectedProperty.id}`, true, "delete");
      setMainData(mainData.filter((item) => item.id !== selectedProperty.id));
      setFilteredData(
        filteredData.filter((item) => item.id !== selectedProperty.id)
      );
      showSnack("Inmueble eliminado exitosamente", "success");
    } catch (e) {
      showSnack(e.message);
    } finally {
      setOpenBackDrop(false);
      setDeleteDialogOpen(false);
      setSelectedProperty(null);
    }
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  function dateToInput(fechaOriginal) {
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${año}-${mes}-${día}`;
    } else return fechaOriginal;
  }

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Inmuebles Aceptados";
    setOpenBackDrop(true);
    loadApi("superadmin/states/approved", true, "get")
      .then((response) => {
        setFilteredData(response.data);
        setMainData(response.data);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setOpenBackDrop(false));
  }, []);

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  console.log(mainData);

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Inmuebles aceptados
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            type={filterType === "m2" ? "number" : "text"}
            value={searchQuery}
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name"}>Nombre</MenuItem>
              <MenuItem value={"location"}>Ubicación</MenuItem>
              <MenuItem value={"m2"}>Metros cuadrados</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Inmuebles encontrados
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Ubicación
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Tipo
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Propósito de uso
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Metros cuadrados
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        sx={{ px: 3, fontWeight: 400, fontSize: "medium" }}
                      >
                        Estado
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Acciones
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.location}</TableCell>
                      <TableCell>{row.type}</TableCell>
                      <TableCell>{row.purpose_use}</TableCell>
                      <TableCell align="right">{row.m2}</TableCell>
                      <TableCell align="center">
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: "#0c1a00",
                            backgroundColor: "#a6ed82a8",
                            width: "fit-content",
                            px: 3,
                            borderRadius: 2,
                          }}
                        >
                          Activo
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Button
                          id={`fade-button-${row.id}`}
                          aria-controls={
                            menuAnchorEl[row.id]
                              ? `fade-menu-${row.id}`
                              : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={
                            Boolean(menuAnchorEl[row.id]) ? "true" : undefined
                          }
                          onClick={(e) => handleMenuClick(e, row.id)}
                          endIcon={<KeyboardArrowDownIcon />}
                        />
                        <Menu
                          id={`fade-menu-${row.id}`}
                          MenuListProps={{
                            "aria-labelledby": `fade-button-${row.id}`,
                          }}
                          anchorEl={menuAnchorEl[row.id]}
                          open={Boolean(menuAnchorEl[row.id])}
                          onClose={() => handleMenuClose(row.id)}
                          TransitionComponent={Fade}
                        >
                          <MenuItem
                            component={Link}
                            to={`/dashboard/edit/property/${row.id}`}
                            onClick={() => handleMenuClose(row.id)}
                            title="Editar inmueble"
                          >
                            <Edit style={{ marginRight: 8 }} /> Editar
                          </MenuItem>
                          <MenuItem
                            component={Link}
                            to={`/dashboard/manage/property/${row.id}`}
                            onClick={() => handleMenuClose(row.id)}
                            title="Ver inmueble"
                          >
                            <AssuredWorkloadIcon style={{ marginRight: 8 }} />
                            {(() => {
                              const purpose = row.purpose_use
                                ?.trim()
                                .toLowerCase();
                              if (purpose === "venta") return "Vender";
                              if (purpose === "arriendo") return "Rentar";
                              return "Gestionar";
                            })()}
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              handleMenuClose(row.id);
                              handleDeleteClick(row);
                            }}
                            title="Eliminar inmueble"
                            color="error"
                          >
                            <DeleteIcon style={{ marginRight: 8 }} /> Eliminar
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea eliminar el inmueble "
            {selectedProperty?.name}"? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancelar</Button>
          <Button onClick={handleDeleteConfirm} color="error">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const PropertySold = ({
  openBackDrop,
  setOpenBackDrop,
  loadApi,
  showSnack,
}) => {
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filterType, setFilterType] = useState("name");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  function dateToInput(fechaOriginal) {
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${año}-${mes}-${día}`;
    } else return fechaOriginal;
  }

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Inmuebles Vendidos";
    setOpenBackDrop(true);
    loadApi("superadmin/states/sold", true, "get")
      .then((response) => {
        setFilteredData(response.data);
        setMainData(response.data);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setOpenBackDrop(false));
  }, []);

  const paginatedData = (filteredData || []).slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Inmuebles vendidos
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            type={filterType === "m2" ? "number" : "text"}
            value={searchQuery}
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name"}>Nombre</MenuItem>
              <MenuItem value={"location"}>Ubicación</MenuItem>
              <MenuItem value={"m2"}>Metros cuadrados</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Inmuebles encontrados
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="30%">Nombre</StyledTableCell>
                    <StyledTableCell>Ubicación</StyledTableCell>
                    <StyledTableCell>Tipo de Inmueble</StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Propósito de uso
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Metros cuadrados
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Ver Inmueble
                    </StyledTableCell>
                    {/* Añade más columnas aquí si es necesario */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell sx={{ whiteSpace: "nowrap" }} width="30%">
                        {row.name}
                      </TableCell>
                      <TableCell>{row.location}</TableCell>
                      <TableCell>{row.type}</TableCell>
                      <TableCell>{row.purpose_use}</TableCell>
                      <TableCell align="right">{row.m2}</TableCell>
                      <TableCell title="Ver Inmueble" align="center">
                        <IconButton
                          LinkComponent={Link}
                          to={"/dashboard/manage/property/" + row.id}
                          size="small"
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>
    </>
  );
};

const PropertyRented = ({
  openBackDrop,
  setOpenBackDrop,
  loadApi,
  showSnack,
}) => {
  const [mainData, setMainData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filterType, setFilterType] = useState("name");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#0B2A41",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: "normal",
    },
  }));

  function dateToInput(fechaOriginal) {
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${año}-${mes}-${día}`;
    } else return fechaOriginal;
  }

  useEffect(() => {
    let data = Searcher(mainData, searchQuery, filterType);
    setFilteredData(data);
  }, [searchQuery]);

  useEffect(() => {
    document.title = "Invirte | Inmuebles Arrendados";
    setOpenBackDrop(true);
    loadApi("superadmin/states/rented", true, "get")
      .then((response) => {
        setFilteredData(response.data);
        setMainData(response.data);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setOpenBackDrop(false));
  }, []);

  const paginatedData = (filteredData || []).slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChange = (event) => {
    setFilterType(event.target.value);
  };

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "90%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h5" mb={3} mt={1}>
          Inmuebles arrendados
        </Typography>
        <Stack flexDirection="row" gap={1}>
          <TextField
            onChange={({ target }) => {
              setSearchQuery(target.value);
            }}
            type={filterType === "m2" ? "number" : "text"}
            value={searchQuery}
            sx={{ width: "70%" }}
            label="Buscar"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ width: "30%" }}>
            <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterType}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"name"}>Nombre</MenuItem>
              <MenuItem value={"location"}>Ubicación</MenuItem>
              <MenuItem value={"m2"}>Metros cuadrados</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Stack>
      <Stack sx={{ mb: 2, width: "90%", marginInline: "auto" }}>
        {!openBackDrop && filteredData.length === 0 ? (
          <Typography component="span" color="GrayText" textAlign="center">
            Sin Inmuebles encontrados
          </Typography>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 640, overflowX: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="30%">Nombre</StyledTableCell>
                    <StyledTableCell>Ubicación</StyledTableCell>
                    <StyledTableCell>Tipo de Inmueble</StyledTableCell>
                    <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                      Propósito de uso
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Metros cuadrados
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Ver Inmueble
                    </StyledTableCell>
                    {/* Añade más columnas aquí si es necesario */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(paginatedData || []).map((row) => (
                    <TableRow hover key={row.id}>
                      <TableCell sx={{ whiteSpace: "nowrap" }} width="30%">
                        {row.name}
                      </TableCell>
                      <TableCell>{row.location}</TableCell>
                      <TableCell>{row.type}</TableCell>
                      <TableCell>{row.purpose_use}</TableCell>
                      <TableCell align="right">{row.m2}</TableCell>
                      <TableCell title="Ver Inmueble" align="center">
                        <IconButton
                          LinkComponent={Link}
                          to={"/dashboard/manage/property/" + row.id}
                          size="small"
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                      {/* Añade más celdas aquí si es necesario */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Stack>
    </>
  );
};

const DashboardComp = ({ loadApi, showSnack, setOpenBackDrop }) => {
  const [dashboardData, setDashboardData] = useState({
    totalInvestorsCount: 0,
    totalInvestedAmount: 0,
    acceptedProjectsCount: 0,
    pendingProjectsCount: 0,
    acceptedStatesCount: 0,
    occupiedStatesCount: 0,
  });

  useEffect(() => {
    document.title = "Invirte | Dashboard";
    setOpenBackDrop(true);
    loadApi("superadmin/dashboard", true, "get")
      .then((response) => {
        setDashboardData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  }, []);

  return (
    <>
      <Stack
        component="header"
        sx={{ mb: 2, width: "95%", marginInline: "auto" }}
      >
        <Typography component="h2" variant="h6" mb={3} mt={1}>
          Panel Administrador
        </Typography>
      </Stack>
      <Stack sx={{ width: "95%", marginInline: "auto" }}>
        <Grid container spacing={{ xs: 0, sm: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Total de Inversores</Typography>
                <Typography variant="h6" sx={{ color: "primary.lighter" }}>
                  {dashboardData?.totalInvestorsCount}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Dinero Invertido Total</Typography>
                <Typography variant="h6" sx={{ color: "primary.lighter" }}>
                  {(dashboardData.totalInvestedAmount || 0).toLocaleString(
                    "es-CO"
                  )}{" "}
                  Є
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Proyectos Aceptados</Typography>
                <Typography variant="h6" sx={{ color: "primary.lighter" }}>
                  {dashboardData.acceptedProjectsCount}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Proyectos Pendientes</Typography>
                <Typography variant="h6" sx={{ color: "primary.lighter" }}>
                  {dashboardData.pendingProjectsCount}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Proyectos Rechazados</Typography>
                <Typography variant="h6" sx={{ color: "primary.lighter" }}>
                  {dashboardData.rejectedProjectsCount}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Inmuebles Aceptados</Typography>
                <Typography variant="h6" sx={{ color: "primary.lighter" }}>
                  {dashboardData.acceptedStatesCount}
                </Typography>
              </CardContent>
            </Card>
          </Grid> */}
          {/* <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Inmuebles Arrendados</Typography>
                <Typography variant="h6" sx={{ color: "primary.lighter" }}>
                  {dashboardData.rentedStatesCount}
                </Typography>
              </CardContent>
            </Card>
          </Grid> */}
          {/* <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">Inmuebles Vendidos</Typography>
                <Typography variant="h6" sx={{ color: "primary.lighter" }}>
                  {dashboardData.soldStatesCount}
                </Typography>
              </CardContent>
            </Card>
          </Grid> */}
        </Grid>
      </Stack>
    </>
  );
};

const SidebarLink = ({ to, currentPath, text, logout = false, icon }) => (
  <Button
    component={Link}
    to={to}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "left",
      gap: ".5em",
      p: 0,
      px: 2,
      py: 1,
      borderRadius: 2,
      mb: 2,
      textTransform: "capitalize",
      whiteSpace: "nowrap",
      color: currentPath === to ? "primary.main" : "#BDDDFA",
      backgroundColor: currentPath === to ? "#BDDDFA" : "primary.main",
      "&:hover": {
        backgroundColor: "#d3eaff",
        color: "primary.300",
      },
    }}
  >
    {icon}
    <Typography>{text}</Typography>
  </Button>
);

function DashboardAdmin() {
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const { loadApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const { pathname } = useLocation();

  return (
    <>
      <HeaderAdmin />
      <Stack
        direction="row"
        sx={{ minHeight: "100vh", width: "100%", backgroundColor: "white" }}
      >
        <Box
          sx={{
            width: 250,
            backgroundColor: "primary.main",
            padding: 2,
            boxShadow: 3,
            display: { xs: "none", lg: "block" },
          }}
        >
          <Stack
            sx={{
              width: 250,
              height: "100vh", // Asegura que el Stack ocupe toda la altura
              backgroundColor: "primary.main",
              color: "white",
              position: "fixed",
              overflow: "auto",
            }}
          >
            <Stack spacing={1} height="100vh" justifyContent="space-between">
              {/* Logo */}
              <Stack textAlign="center" mb={4} pl={2} pt={2}>
                <InvirteLogoComponent width={{ xs: 90, md: 100, lg: 110 }} />
              </Stack>

              {/* Opciones del menú */}

              <Stack>
                <SidebarLink
                  to="/dashboard"
                  currentPath={pathname}
                  text={"Dashboard"}
                  icon={<SpaceDashboardIcon />}
                />
                {/* <SidebarLink
                  to="/dashboard/create/property"
                  currentPath={pathname}
                  text={"Crear Inmueble"}
                  icon={<MapsHomeWorkIcon />}
                />
                <SidebarLink
                  to="/dashboard/property/accepted"
                  currentPath={pathname}
                  text={"Inmuebles"}
                  icon={<MapsHomeWorkIcon />}
                />
                <SidebarLink
                  to="/dashboard/property/sold"
                  currentPath={pathname}
                  text={"Inmuebles Vendidos"}
                  icon={<MapsHomeWorkIcon />}
                />
                <SidebarLink
                  to="/dashboard/property/rented"
                  currentPath={pathname}
                  text={"Inmuebles Arrendados"}
                  icon={<MapsHomeWorkIcon />}
                />
                <SidebarLink
                  to="/dashboard/property/interest"
                  currentPath={pathname}
                  text={"Interesados inmuebles"}
                  icon={<PersonIcon />}
                />
                <SidebarLink
                  to="/dashboard/property/contacted"
                  currentPath={pathname}
                  text={"Interesados contactados"}
                  icon={<PersonIcon />}
                /> */}
                <SidebarLink
                  to="/dashboard/projects/accepted"
                  currentPath={pathname}
                  text={"Proyectos Aceptados"}
                  icon={<AutoGraphIcon />}
                />
                <SidebarLink
                  to="/dashboard/projects/pending"
                  currentPath={pathname}
                  text={"Proyectos Pendientes"}
                  icon={<AutoGraphIcon />}
                />
                <SidebarLink
                  to="/dashboard/projects/rejected"
                  currentPath={pathname}
                  text={"Proyectos Rechazados"}
                  icon={<AutoGraphIcon />}
                />
                <SidebarLink
                  to="/dashboard/investments/accepted"
                  currentPath={pathname}
                  text={"Inversiones aceptadas"}
                  icon={<BusinessCenterIcon />}
                />
                <SidebarLink
                  to="/dashboard/investments/pending"
                  currentPath={pathname}
                  text={"Inversiones Pendientes"}
                  icon={<BusinessCenterIcon />}
                />
                <SidebarLink
                  to="/dashboard/investments/rejected"
                  currentPath={pathname}
                  text={"Inversiones Rechazadas"}
                  icon={<BusinessCenterIcon />}
                />
              </Stack>
              <Stack>
                <SidebarLink
                  to="/logout"
                  currentPath={pathname}
                  text={"Cerrar sesión"}
                  logout={true}
                  icon={<LogoutIcon />}
                />
              </Stack>
            </Stack>
          </Stack>
        </Box>
        <Box
          sx={{
            padding: { xs: 0, lg: 3 },
            pt: 6,
            width: {
              xs: "100%",
              lg: "calc(100% - 250px)",
            },
          }}
        >
          {pathname === "/dashboard" ? (
            <DashboardComp
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/projects/accepted" ? (
            <ProjectsAccept
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/projects/pending" ? (
            <ProjectsPending
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/projects/rejected" ? (
            <ProjectsRejected
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/property/accepted" ? (
            <PropertyAccept
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/property/sold" ? (
            <PropertySold
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/property/rented" ? (
            <PropertyRented
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/investments/accepted" ? (
            <InvestmentsAccepted
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/investments/pending" ? (
            <InvestmentsPending
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/investments/rejected" ? (
            <InvestmentsRejected
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/property/interest" ? (
            <InterestedProperty
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/property/contacted" ? (
            <ContactedProperty
              loadApi={loadApi}
              setOpenBackDrop={setOpenBackDrop}
              showSnack={showSnack}
              openBackDrop={openBackDrop}
            />
          ) : pathname === "/dashboard/create/property" ? (
            <NewProperty />
          ) : (
            ""
          )}
        </Box>
      </Stack>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default DashboardAdmin;

